export default "__VITE_ASSET__DxyHUiEW__"